/**
 * @generated SignedSource<<d5b04389a93bcfbb1955e5f4c743f912>>
 * @relayHash 44a5fa3081e3fcf2577d2551414286a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f721f5226aa630ddddb0af9a4eab615cdc6b166cfdadeb13965743884fdd0622

import type { ConcreteRequest, Query } from 'relay-runtime';
export type TopNavSettingsMenuQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
};
export type TopNavSettingsMenuQuery$data = {
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null | undefined;
  } | null | undefined;
};
export type TopNavSettingsMenuQuery = {
  response: TopNavSettingsMenuQuery$data;
  variables: TopNavSettingsMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  }
],
v1 = [
  {
    "condition": "skipDelegatedAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canManageCustomOnboarding",
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "key",
                "value": "ADMINISTER"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f721f5226aa630ddddb0af9a4eab615cdc6b166cfdadeb13965743884fdd0622",
    "metadata": {},
    "name": "TopNavSettingsMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6dc42725ac90b84cf40b696804be3bbd";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
